
import { Vue } from 'vue-class-component'
import { getCharCode } from '@/helpers/charCode'
import { Prop } from 'vue-property-decorator'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'

export default class VersionCopyright extends Vue {
  @Prop() copyRightDate!: string

  private githash = process.env.VUE_APP_GITHASH
  private version = process.env.VUE_APP_VERSION
  private githashLast3Digits: string = this.githash ? this.githash.slice(-3) : ''
  private charCodeGithush: string = getCharCode(this.githashLast3Digits)
  private yearCopyRight = ''

  async created() {
    this.yearCopyRight = this.copyRightDate
      ? new Date(this.copyRightDate).getFullYear().toString()
      : ''
  }

  settingCookies() {
    addGAEvent({
      event: 'setting_cookies_text',
    })
    const consentButton = document.getElementById('silktide-cookie-icon')
    consentButton?.click()
  }
}
